<atlas-language-list-item
  class="atlas-navbar__language-list-item"
  *ngFor="let language of languages"
  [language]="language"
  (languageSelected)="selectLanguage($event)"
></atlas-language-list-item>
